import { getCarrierServiceLabel } from "@redotech/redo-fulfillment-carrier-common/carrier-service-labels";
import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getShippingSelectionCellData } from "./fulfillment-group-csv-helpers";

export const ShippingSelectionCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Shipping selection",
    cell: (row) => {
      if (row.ratesPendingSince) {
        return "";
      }

      const data = getShippingSelectionCellData(row);

      if (data) {
        return `${getCarrierServiceLabel(data.carrierName, data.serviceName)} - ${data.rate ?? "unknown"} - ${data.deliveryDays ?? "unknown"}`;
      } else if (row.ratesErrorMessage) {
        return row.ratesErrorMessage;
      } else {
        return "";
      }
    },
  };
